module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addressSelector"
  }, [(_vm.addresses.length > 0) ? _c('div', [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('order.chooseAddress')
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, _vm._l((_vm.addresses), function(item) {
    return _c('el-option', {
      key: item.title,
      attrs: {
        "label": item.title,
        "value": item
      }
    })
  })), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseAddress()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('order.select')))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88c7c7b6"}!./src/components/addressSelector/addressSelector.html
// module id = 816
// module chunks = 1